import type { GlobalObjectType } from './types';

export const ALL_SUPPORTED_OBJECTS: GlobalObjectType[] = [
	'jira-issue',
	'confluence-page',
	'identity-team',
	'townsquare-goal',
	'townsquare-project',
	'cmdb-object',
	'loom-video',
];
